
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1sdq3_aboem_12",
  "input": "awsui_input_1sdq3_aboem_47",
  "results": "awsui_results_1sdq3_aboem_51"
};
  